<template>
  <Popover class="relative">
    <Float
      portal
      placement="bottom-start"
      :offset="10"
      :flip="true"
      :shift="16"
      enter="transition duration-200 ease-out"
      enter-from="translate-y-1 opacity-0"
      enter-to="translate-y-0 opacity-100"
      leave="transition duration-150 ease-in"
      leave-from="translate-y-0 opacity-100"
      leave-to="translate-y-1 opacity-0"
    >
      <PopoverButton
        class="inline-flex items-center justify-between gap-3 rounded-md border border-slate-300 bg-white px-3 py-2 font-medium text-gray-600 focus:outline-hidden dark:bg-slate-700 dark:text-gray-300"
      >
        <FontAwesomeIcon :icon="['fal', 'sliders-h']" />
        <span class="text-xs font-medium capitalize-first">
          {{ $t('global.filters') }}
        </span>
        <FontAwesomeIcon :icon="['fal', 'chevron-down']" />
      </PopoverButton>
      <PopoverPanel class="z-100 w-screen max-w-sm px-4 sm:px-0 lg:max-w-3xl">
        <div class="rounded-md border bg-white shadow-2xl dark:bg-slate-700">
          <div class="relative space-y-5 rounded-md p-5">
            <div>
              <!--               TODO: trad-->
              <h2 class="mb-2 text-xl font-bold capitalize-first">
                {{ $t('global.cremation_date') }}
              </h2>
              <div class="flex flex-wrap space-x-3">
                <div
                  v-for="(filter, index) in filters"
                  :key="index"
                  :class="filter.selected ? 'bg-primary-500 text-white' : ''"
                  class="cursor-pointer rounded-md bg-gray-300 px-2 py-1 text-black capitalize-first shadow-md"
                  @click="setFilter(index)"
                >
                  {{ filter.title }}
                </div>
              </div>
              <h2 class="mt-3 mb-2 text-xl font-bold capitalize-first">
                {{ $t('global.work_status') }}
              </h2>
              <span
                v-for="(item, index) in metadata.status"
                :key="index"
                @click="setOtherFilter(item)"
                :class="
                  status.includes(item.id) ? 'bg-primary-500 text-white' : ''
                "
                class="mt-2 mr-2 inline-flex cursor-pointer items-center rounded-md bg-gray-300 px-2 py-1 text-black capitalize-first shadow-md"
              >
                <svg
                  :class="`mr-1.5 h-2 w-2 text-theme-${item.bg_color}`"
                  fill="currentColor"
                  viewBox="0 0 8 8"
                >
                  <circle cx="4" cy="4" r="3" />
                </svg>
                {{ item.name }}
              </span>
              <div class="mt-3 flex flex-row-reverse">
                <BaseButton
                  color="danger"
                  icon="times"
                  :title="$t('global.reset_filter')"
                  @click="resetFilter"
                />
              </div>
              <h2 class="mt-4 text-xl font-bold capitalize-first">
                {{ $t('global.customers') }}
              </h2>
              <BaseSelectMultiple
                v-if="metadata.customers"
                label=""
                :placeholder="$t('global.customer')"
                name="customer"
                :value="null"
                :options="metadata.customers"
                selectClass=" mx-4"
                @setSelected.self="handleFilterTable"
              />
            </div>
          </div>
        </div>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import {
  Popover,
  PopoverButton,
  PopoverOverlay,
  PopoverPanel
} from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Float } from '@headlessui-float/vue'

import WorkFilterModelDropdown from '@p/works/index/components/WorkFilterModelDropdown'
import { mapGetters } from 'vuex'

export default {
  name: 'TheWorkIndexSettingsComponent',
  components: {
    Float,
    FontAwesomeIcon,
    Popover,
    PopoverButton,
    PopoverPanel,
    PopoverOverlay,
    WorkFilterModelDropdown
  },
  emits: ['update:arrayFilter'],
  props: {
    arrayFilter: { type: Array, required: false, default: [] }
  },
  data() {
    return {
      filters: [
        { title: this.$t('global.today'), value: 'today', selected: false },
        {
          title: this.$t('global.tomorrow'),
          value: 'tomorrow',
          selected: false
        },
        {
          title: this.$t('global.day_after_tomorrow'),
          value: 'day_after_tomorrow',
          selected: false
        }
      ],
      status: [],
      filter: {}
    }
  },
  computed: {
    ...mapGetters({ metadata: 'work/getWorkMetadata' })
  },
  methods: {
    setFilter(index) {
      this.filters[index].selected = !this.filters[index].selected
      this.$emit('filterChange', this.filters[index])
    },
    setOtherFilter(payload) {
      if (this.status.includes(payload.id)) {
        this.status = this.status.filter((status) => status !== payload.id)
        this.$emit('otherFilterChange', this.status)
      } else {
        this.status.push(payload.id)
        this.$emit('otherFilterChange', this.status)
      }
    },
    handleFilterTable({ attribute, value }) {
      this.filter[attribute] = value
      this.$emit('customerFilter', this.filter)
    },
    resetFilter(attribute) {
      this.filters.forEach((filter) => (filter.selected = false))
      this.status = []
      this.$emit('resetFilter')
    }
  }
}
</script>
